const errorDetails = (error: unknown): { code: string; message: string } => {
  const value = error as { code?: unknown; message?: unknown };
  return {
    code: typeof value?.code === "string" ? value.code.toLowerCase() : "",
    message:
      typeof value?.message === "string" ? value.message.toLowerCase() : "",
  };
};

const RETRY_BASE_DELAY_MS = 1_000;
const RETRY_MAX_DELAY_MS = 30_000;

export const sharedListListenerRetryDelayMs = (attempt: number): number =>
  Math.min(RETRY_BASE_DELAY_MS * 2 ** attempt, RETRY_MAX_DELAY_MS);

export const isSharedListAccessRevocationError = (error: unknown): boolean => {
  const { code, message } = errorDetails(error);
  return (
    code.includes("permission-denied") ||
    code.includes("not-found") ||
    message.includes("permission-denied") ||
    message.includes("insufficient permissions") ||
    message.includes("not-found")
  );
};

export const isRetryableSharedListListenerError = (error: unknown): boolean => {
  const { code, message } = errorDetails(error);
  return (
    code.includes("unavailable") ||
    code.includes("deadline-exceeded") ||
    code.includes("cancelled") ||
    code.includes("network-request-failed") ||
    message.includes("temporarily unavailable") ||
    message.includes("network") ||
    message.includes("offline") ||
    message.includes("failed to fetch")
  );
};
